export default {"src":"/_next/static/media/pro_hosts_slate.9b56fbd4.svg","height":507,"width":507,"blurWidth":0,"blurHeight":0};